import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Seo } from "@/components/Seo";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import ContactForm from "@/components/site/ContactForm";
import { useState } from "react";


const About = () => {
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  
  return (
    <main className="pb-24">
      <Seo title="About Andres Ravinet - AI Montclair Founder" description="Meet the founder: 20+ years in tech, Microsoft veteran, Montclair resident helping local businesses automate with AI." canonical="/about" />
      <Navbar />

      <section className="py-16 md:py-24">
        <div className="container mx-auto grid gap-8 md:grid-cols-2 items-start">
          <div>
            <h1 className="text-3xl md:text-4xl font-semibold">About Me</h1>
            <p className="text-muted-foreground mt-3">
              Montclair resident, technologist, and community-focused automation specialist.
            </p>
            <div className="mt-6 space-y-4">
              <p>
                {"I'm Andres Ravinet, a Montclair resident, husband and dad, and a technologist with 20+ years building solutions for small and large organizations. I've been with Microsoft for neraly a decade designing strategy and enterprise solutions; now I focus that experience on my own community—helping Montclair's small businesses and nonprofits save time with secure and straightforward AI automation."}
              </p>
              <p>
                {"We firmly advocate for equitable access to technology and are committed to supporting marginalized communities."}
              </p>
              <p>
                I dedicate discounted/pro-bono time each month to local nonprofits.
              </p>
              <div className="mt-6">
                <h3 className="text-xl font-semibold mb-2">Inclusivity</h3>
                <p className="text-muted-foreground">
                  We welcome and serve all people. Accessibility and privacy are considered at every step so tools work for everyone in our community.
                </p>
              </div>
            </div>
            <div className="mt-6">
              <Dialog open={contactDialogOpen} onOpenChange={setContactDialogOpen}>
                <DialogTrigger asChild>
                  <Button variant="secondary">Book a 15‑min intro</Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[640px]">
                  <DialogHeader>
                    <DialogTitle>Get in Touch</DialogTitle>
                    <DialogDescription>
                      Tell us about your goals. We'll propose quick wins and an automation plan.
                    </DialogDescription>
                  </DialogHeader>
                  <ContactForm onSubmitted={() => setContactDialogOpen(false)} />
                </DialogContent>
              </Dialog>
            </div>
          </div>

          <div>
            <AspectRatio ratio={3 / 4}>
              <img src="/lovable-uploads/9e5814cb-d745-4977-94cd-d278473bd69b.png" alt="Portrait of Andres Ravinet" className="h-full w-full object-contain object-center rounded-lg" loading="lazy" />
            </AspectRatio>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default About;